// Textos da Assinatura do ponto (26/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.ponto.titulo': 'Assinatura do ponto',
    'dp.ponto.eyebrow': 'Departamento Pessoal',
    'dp.ponto.abrir': 'Abrir competência',
    'dp.ponto.aberta': '{{n}} pessoas entraram na competência.',
    'dp.ponto.naoAberta': 'A competência {{rotulo}} ainda não foi aberta. Abrir semeia os motoristas e operadores das filiais do DP com vínculo no período; a planilha de controle também abre a competência ao ser importada.',
    'dp.ponto.prazoExplica': 'O espelho de {{rotulo}} se assina na ATS até {{data}}. Quem não assina perde o vale-alimentação da competência seguinte e o bônus.',
    'dp.ponto.kpi.pendentes': 'Não assinaram',
    'dp.ponto.kpi.assinados': 'Assinaram',
    'dp.ponto.kpi.foraDoPrazo': 'Fora do prazo',
    'dp.ponto.kpi.isentos': 'Isentos',
    'dp.ponto.kpi.total': 'Total',
    'dp.ponto.col.pessoa': 'Pessoa',
    'dp.ponto.col.filial': 'Filial',
    'dp.ponto.col.situacao': 'Situação',
    'dp.ponto.col.acoes': 'Ações',
    'dp.ponto.assinadoEm': 'Assinou em {{data}}',
    'dp.ponto.foraDoPrazo': 'Fora do prazo',
    'dp.ponto.origem.planilha': 'Da planilha',
    'dp.ponto.origem.ats': 'Da ATS',
    'dp.ponto.origem.hub': 'Marcado no Hub',
    'dp.ponto.marcar': 'Marcar',
    'dp.ponto.cobrar': 'Cobrar',
    'dp.ponto.situacao.pendente': 'Não assinou',
    'dp.ponto.situacao.assinado': 'Assinou',
    'dp.ponto.situacao.recem_admitido': 'Recém-admitido',
    'dp.ponto.situacao.desligado': 'Desligado',
    'dp.ponto.situacao.afastado': 'Afastado',
    'dp.ponto.situacao.dispensado': 'Dispensado do corte',
    'dp.ponto.marcarTitulo': 'Assinatura de {{nome}}',
    'dp.ponto.marcarData': 'Data da assinatura',
    'dp.ponto.marcarObs': 'Observação',
    'dp.ponto.marcarObsDispensa': 'Motivo da dispensa',
    'dp.ponto.marcarSalvar': 'Salvar',
    'dp.ponto.cobrancaTitulo': 'Cobrar {{nome}}',
    'dp.ponto.cobrancaCopiar': 'Copiar texto',
    'dp.ponto.cobrancaCopiado': 'Texto copiado.',
    'dp.ponto.cobrancaWhatsapp': 'Abrir no WhatsApp',
    'dp.ponto.cobrancaRegistrar': 'Registrar a cobrança',
    'dp.ponto.cobrancaRegistrada': 'Cobrança registrada.',
    'dp.ponto.cobrancaSemTelefone': 'Sem telefone no cadastro. Copie o texto e mande pelo WhatsApp do DP.',
    'dp.ponto.cobrancaTelefoneMascarado': 'O telefone do cadastro termina em {{final}} e só aparece inteiro para quem vê dados pessoais. Copie o texto e mande pelo WhatsApp do DP.',
    'dp.ponto.cobrancaTexto': 'Cobrança do espelho enviada pelo WhatsApp.',
    'dp.ponto.importarTitulo': 'Importar a planilha de controle de assinatura',
    'dp.ponto.importarExplica': 'O export de documentos assinados da ATS, em CSV, ou a planilha CONTROLE ASSINATURA CARTAO DE PONTO. O export só traz o nome: o Hub liga cada condutor a uma pessoa da competência e avisa quem não achou. Primeiro o Hub mostra a prévia; nada é gravado antes de confirmar. Célula vazia não apaga a assinatura que o Hub já tem nem a situação marcada na tela.',
    'dp.ponto.importarEscolher': 'Escolher arquivo',
    'dp.ponto.importarPrevia': 'Ver prévia',
    'dp.ponto.importarConfirmar': 'Importar {{n}} competências',
    'dp.ponto.importarFeita': 'Planilha importada.',
    'dp.ponto.importarCol.competencia': 'Competência',
    'dp.ponto.importarCol.linhas': 'Pessoas',
    'dp.ponto.importarCol.assinados': 'Assinaram',
    'dp.ponto.importarCol.pendentes': 'Não assinaram',
    'dp.ponto.importarCol.isentos': 'Isentos',
    'dp.ponto.importarCol.fora': 'Outras filiais',
    'dp.ponto.importarCol.semPessoa': 'Sem cadastro no Hub',
    'dp.ponto.importarCol.situacao': 'Na base',
    'dp.ponto.importarFechada': 'Fechada, não muda',
    'dp.ponto.importarJaAberta': 'Já aberta, atualiza',
    'dp.ponto.importarNova': 'Nova',
    'dp.ponto.importarAvisos': '{{n}} linhas puladas',
  },
  en: {
    'dp.ponto.titulo': 'Timesheet signature',
    'dp.ponto.eyebrow': 'Personnel Department',
    'dp.ponto.abrir': 'Open pay period',
    'dp.ponto.aberta': '{{n}} people were added to the pay period.',
    'dp.ponto.naoAberta': 'The {{rotulo}} pay period has not been opened yet. Opening adds the drivers and operators of the covered branches employed in the period; importing the control spreadsheet also opens it.',
    'dp.ponto.prazoExplica': 'The {{rotulo}} timesheet is signed in ATS by {{data}}. Whoever does not sign loses the next meal allowance and the bonus.',
    'dp.ponto.kpi.pendentes': 'Not signed',
    'dp.ponto.kpi.assinados': 'Signed',
    'dp.ponto.kpi.foraDoPrazo': 'Signed late',
    'dp.ponto.kpi.isentos': 'Exempt',
    'dp.ponto.kpi.total': 'Total',
    'dp.ponto.col.pessoa': 'Person',
    'dp.ponto.col.filial': 'Branch',
    'dp.ponto.col.situacao': 'Status',
    'dp.ponto.col.acoes': 'Actions',
    'dp.ponto.assinadoEm': 'Signed on {{data}}',
    'dp.ponto.foraDoPrazo': 'Late',
    'dp.ponto.origem.planilha': 'From spreadsheet',
    'dp.ponto.origem.ats': 'From ATS',
    'dp.ponto.origem.hub': 'Marked in the Hub',
    'dp.ponto.marcar': 'Mark',
    'dp.ponto.cobrar': 'Remind',
    'dp.ponto.situacao.pendente': 'Not signed',
    'dp.ponto.situacao.assinado': 'Signed',
    'dp.ponto.situacao.recem_admitido': 'Newly hired',
    'dp.ponto.situacao.desligado': 'Terminated',
    'dp.ponto.situacao.afastado': 'On leave',
    'dp.ponto.situacao.dispensado': 'Exempted from cut',
    'dp.ponto.marcarTitulo': 'Signature of {{nome}}',
    'dp.ponto.marcarData': 'Signature date',
    'dp.ponto.marcarObs': 'Note',
    'dp.ponto.marcarObsDispensa': 'Reason for exemption',
    'dp.ponto.marcarSalvar': 'Save',
    'dp.ponto.cobrancaTitulo': 'Remind {{nome}}',
    'dp.ponto.cobrancaCopiar': 'Copy text',
    'dp.ponto.cobrancaCopiado': 'Text copied.',
    'dp.ponto.cobrancaWhatsapp': 'Open in WhatsApp',
    'dp.ponto.cobrancaRegistrar': 'Record the reminder',
    'dp.ponto.cobrancaRegistrada': 'Reminder recorded.',
    'dp.ponto.cobrancaSemTelefone': 'No phone number on file. Copy the text and send it from the department WhatsApp.',
    'dp.ponto.cobrancaTelefoneMascarado': 'The phone number on file ends in {{final}} and is only shown in full to users who can see personal data. Copy the text and send it from the department WhatsApp.',
    'dp.ponto.cobrancaTexto': 'Timesheet reminder sent by WhatsApp.',
    'dp.ponto.importarTitulo': 'Import the signature control spreadsheet',
    'dp.ponto.importarExplica': 'The ATS signed documents export, in CSV, or the CONTROLE ASSINATURA CARTAO DE PONTO spreadsheet. The export only has the name: the Hub links each driver to a person in the pay period and flags whoever it did not find. The Hub shows a preview first; nothing is saved before you confirm. An empty cell does not erase a signature the Hub already has nor a situation set on the screen.',
    'dp.ponto.importarEscolher': 'Choose file',
    'dp.ponto.importarPrevia': 'Preview',
    'dp.ponto.importarConfirmar': 'Import {{n}} pay periods',
    'dp.ponto.importarFeita': 'Spreadsheet imported.',
    'dp.ponto.importarCol.competencia': 'Pay period',
    'dp.ponto.importarCol.linhas': 'People',
    'dp.ponto.importarCol.assinados': 'Signed',
    'dp.ponto.importarCol.pendentes': 'Not signed',
    'dp.ponto.importarCol.isentos': 'Exempt',
    'dp.ponto.importarCol.fora': 'Other branches',
    'dp.ponto.importarCol.semPessoa': 'Not in the Hub',
    'dp.ponto.importarCol.situacao': 'In the base',
    'dp.ponto.importarFechada': 'Closed, unchanged',
    'dp.ponto.importarJaAberta': 'Already open, updates',
    'dp.ponto.importarNova': 'New',
    'dp.ponto.importarAvisos': '{{n}} rows skipped',
  },
  es: {
    'dp.ponto.titulo': 'Firma de la hoja de asistencia',
    'dp.ponto.eyebrow': 'Departamento de Personal',
    'dp.ponto.abrir': 'Abrir período',
    'dp.ponto.aberta': '{{n}} personas entraron en el período.',
    'dp.ponto.naoAberta': 'El período {{rotulo}} aún no fue abierto. Abrir agrega a los conductores y operadores de las sucursales cubiertas con vínculo en el período; importar la planilla de control también lo abre.',
    'dp.ponto.prazoExplica': 'La hoja de {{rotulo}} se firma en ATS hasta el {{data}}. Quien no firma pierde el vale de alimentación siguiente y el bono.',
    'dp.ponto.kpi.pendentes': 'No firmaron',
    'dp.ponto.kpi.assinados': 'Firmaron',
    'dp.ponto.kpi.foraDoPrazo': 'Fuera de plazo',
    'dp.ponto.kpi.isentos': 'Exentos',
    'dp.ponto.kpi.total': 'Total',
    'dp.ponto.col.pessoa': 'Persona',
    'dp.ponto.col.filial': 'Sucursal',
    'dp.ponto.col.situacao': 'Situación',
    'dp.ponto.col.acoes': 'Acciones',
    'dp.ponto.assinadoEm': 'Firmó el {{data}}',
    'dp.ponto.foraDoPrazo': 'Fuera de plazo',
    'dp.ponto.origem.planilha': 'De la planilla',
    'dp.ponto.origem.ats': 'De ATS',
    'dp.ponto.origem.hub': 'Marcado en el Hub',
    'dp.ponto.marcar': 'Marcar',
    'dp.ponto.cobrar': 'Cobrar',
    'dp.ponto.situacao.pendente': 'No firmó',
    'dp.ponto.situacao.assinado': 'Firmó',
    'dp.ponto.situacao.recem_admitido': 'Recién contratado',
    'dp.ponto.situacao.desligado': 'Desvinculado',
    'dp.ponto.situacao.afastado': 'Con licencia',
    'dp.ponto.situacao.dispensado': 'Exento del corte',
    'dp.ponto.marcarTitulo': 'Firma de {{nome}}',
    'dp.ponto.marcarData': 'Fecha de la firma',
    'dp.ponto.marcarObs': 'Observación',
    'dp.ponto.marcarObsDispensa': 'Motivo de la exención',
    'dp.ponto.marcarSalvar': 'Guardar',
    'dp.ponto.cobrancaTitulo': 'Cobrar a {{nome}}',
    'dp.ponto.cobrancaCopiar': 'Copiar texto',
    'dp.ponto.cobrancaCopiado': 'Texto copiado.',
    'dp.ponto.cobrancaWhatsapp': 'Abrir en WhatsApp',
    'dp.ponto.cobrancaRegistrar': 'Registrar el cobro',
    'dp.ponto.cobrancaRegistrada': 'Cobro registrado.',
    'dp.ponto.cobrancaSemTelefone': 'Sin teléfono en el registro. Copie el texto y envíelo por el WhatsApp del departamento.',
    'dp.ponto.cobrancaTelefoneMascarado': 'El teléfono del registro termina en {{final}} y solo aparece completo para quien ve datos personales. Copie el texto y envíelo por el WhatsApp del departamento.',
    'dp.ponto.cobrancaTexto': 'Cobro de la hoja enviado por WhatsApp.',
    'dp.ponto.importarTitulo': 'Importar la planilla de control de firmas',
    'dp.ponto.importarExplica': 'La exportación de documentos firmados de la ATS, en CSV, o la planilla CONTROLE ASSINATURA CARTAO DE PONTO. La exportación solo trae el nombre: el Hub vincula cada conductor a una persona del período y avisa a quien no encontró. El Hub muestra primero la vista previa; nada se guarda antes de confirmar. Una celda vacía no borra la firma que el Hub ya tiene ni la situación marcada en la pantalla.',
    'dp.ponto.importarEscolher': 'Elegir archivo',
    'dp.ponto.importarPrevia': 'Vista previa',
    'dp.ponto.importarConfirmar': 'Importar {{n}} períodos',
    'dp.ponto.importarFeita': 'Planilla importada.',
    'dp.ponto.importarCol.competencia': 'Período',
    'dp.ponto.importarCol.linhas': 'Personas',
    'dp.ponto.importarCol.assinados': 'Firmaron',
    'dp.ponto.importarCol.pendentes': 'No firmaron',
    'dp.ponto.importarCol.isentos': 'Exentos',
    'dp.ponto.importarCol.fora': 'Otras sucursales',
    'dp.ponto.importarCol.semPessoa': 'Sin registro en el Hub',
    'dp.ponto.importarCol.situacao': 'En la base',
    'dp.ponto.importarFechada': 'Cerrado, no cambia',
    'dp.ponto.importarJaAberta': 'Ya abierto, actualiza',
    'dp.ponto.importarNova': 'Nuevo',
    'dp.ponto.importarAvisos': '{{n}} filas omitidas',
  },
}
